"use strict";

var _classCallCheck = require("D:\\BuildAgent\\work\\REL\\packages\\vms\\node_modules\\@babel\\runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var UserNotificationSettingRequest = function UserNotificationSettingRequest(params) {
  _classCallCheck(this, UserNotificationSettingRequest);

  this.resourceParams = params;
  this.resourceType = 'UserNotificationSetting';
};

exports.UserNotificationSettingRequest = UserNotificationSettingRequest;

var UserNotificationCountRequest = function UserNotificationCountRequest(params) {
  _classCallCheck(this, UserNotificationCountRequest);

  this.resourceParams = params;
  this.resourceType = 'UserNotificationCount';
};

exports.UserNotificationCountRequest = UserNotificationCountRequest;

var UserNotificationRequest = function UserNotificationRequest(params) {
  _classCallCheck(this, UserNotificationRequest);

  this.resourceParams = params;
  this.resourceType = 'UserNotification';
};

exports.UserNotificationRequest = UserNotificationRequest;

var CustomFieldRequest = function CustomFieldRequest(params) {
  _classCallCheck(this, CustomFieldRequest);

  this.resourceParams = params;
  this.resourceType = 'CustomField';
};

exports.CustomFieldRequest = CustomFieldRequest;

var BroadcastMessageRequest = function BroadcastMessageRequest(params) {
  _classCallCheck(this, BroadcastMessageRequest);

  this.resourceParams = params;
  this.resourceType = 'BroadcastMessage';
};

exports.BroadcastMessageRequest = BroadcastMessageRequest;

var PermissionRequest = function PermissionRequest(params) {
  _classCallCheck(this, PermissionRequest);

  this.resourceParams = params;
  this.resourceType = 'Permission';
};

exports.PermissionRequest = PermissionRequest;

var ApprovalRejectionReasonRequest = function ApprovalRejectionReasonRequest(params) {
  _classCallCheck(this, ApprovalRejectionReasonRequest);

  this.resourceParams = params;
  this.resourceType = 'ApprovalRejectionReason';
};

exports.ApprovalRejectionReasonRequest = ApprovalRejectionReasonRequest;

var DataPreferencesRequest = function DataPreferencesRequest(params) {
  _classCallCheck(this, DataPreferencesRequest);

  this.resourceParams = params;
  this.resourceType = 'DataPreferences';
};

exports.DataPreferencesRequest = DataPreferencesRequest;

var MatchAttachmentsRequest = function MatchAttachmentsRequest(params) {
  _classCallCheck(this, MatchAttachmentsRequest);

  this.resourceParams = params;
  this.resourceType = 'MatchAttachments';
};

exports.MatchAttachmentsRequest = MatchAttachmentsRequest;

var ShiftScheduleRequest = function ShiftScheduleRequest(params) {
  _classCallCheck(this, ShiftScheduleRequest);

  this.resourceParams = params;
  this.resourceType = 'ShiftSchedule';
};

exports.ShiftScheduleRequest = ShiftScheduleRequest;

var ShiftBonusRequest = function ShiftBonusRequest(params) {
  _classCallCheck(this, ShiftBonusRequest);

  this.resourceParams = params;
  this.resourceType = 'ShiftBonus';
};

exports.ShiftBonusRequest = ShiftBonusRequest;

var ShiftRequest = function ShiftRequest(params) {
  _classCallCheck(this, ShiftRequest);

  this.resourceParams = params;
  this.resourceType = 'Shift';
};

exports.ShiftRequest = ShiftRequest;

var ShiftSearchCreatedByRequest = function ShiftSearchCreatedByRequest(params) {
  _classCallCheck(this, ShiftSearchCreatedByRequest);

  this.resourceParams = params;
  this.resourceType = 'ShiftSearchCreatedBy';
};

exports.ShiftSearchCreatedByRequest = ShiftSearchCreatedByRequest;

var AboutTypeFacilityDepartmentsRequest = function AboutTypeFacilityDepartmentsRequest(params) {
  _classCallCheck(this, AboutTypeFacilityDepartmentsRequest);

  this.resourceParams = params;
  this.resourceType = 'AboutTypeFacilityDepartments';
};

exports.AboutTypeFacilityDepartmentsRequest = AboutTypeFacilityDepartmentsRequest;

var AgreementRequest = function AgreementRequest(params) {
  _classCallCheck(this, AgreementRequest);

  this.resourceParams = params;
  this.resourceType = 'Agreement';
};

exports.AgreementRequest = AgreementRequest;

var ApprovalPathRequest = function ApprovalPathRequest(params) {
  _classCallCheck(this, ApprovalPathRequest);

  this.resourceParams = params;
  this.resourceType = 'ApprovalPath';
};

exports.ApprovalPathRequest = ApprovalPathRequest;

var ApprovalPathOverviewRequest = function ApprovalPathOverviewRequest(params) {
  _classCallCheck(this, ApprovalPathOverviewRequest);

  this.resourceParams = params;
  this.resourceType = 'ApprovalPathOverview';
};

exports.ApprovalPathOverviewRequest = ApprovalPathOverviewRequest;

var ApprovalPathTimelineRequest = function ApprovalPathTimelineRequest(params) {
  _classCallCheck(this, ApprovalPathTimelineRequest);

  this.resourceParams = params;
  this.resourceType = 'ApprovalPathTimeline';
};

exports.ApprovalPathTimelineRequest = ApprovalPathTimelineRequest;

var CandidateResumeRequest = function CandidateResumeRequest(params) {
  _classCallCheck(this, CandidateResumeRequest);

  this.resourceParams = params;
  this.resourceType = 'CandidateResume';
};

exports.CandidateResumeRequest = CandidateResumeRequest;

var CandidateWorkHistoryRequest = function CandidateWorkHistoryRequest(params) {
  _classCallCheck(this, CandidateWorkHistoryRequest);

  this.resourceParams = params;
  this.resourceType = 'CandidateWorkHistory';
};

exports.CandidateWorkHistoryRequest = CandidateWorkHistoryRequest;

var UserRequest = function UserRequest(params) {
  _classCallCheck(this, UserRequest);

  this.resourceParams = params;
  this.resourceType = 'User';
};

exports.UserRequest = UserRequest;

var RecruiterRequest = function RecruiterRequest(params) {
  _classCallCheck(this, RecruiterRequest);

  this.resourceParams = params;
  this.resourceType = 'Recruiter';
};

exports.RecruiterRequest = RecruiterRequest;

var AddressRequest = function AddressRequest(params) {
  _classCallCheck(this, AddressRequest);

  this.resourceParams = params;
  this.resourceType = 'Address';
};

exports.AddressRequest = AddressRequest;

var ShiftCancellationReasonRequest = function ShiftCancellationReasonRequest(params) {
  _classCallCheck(this, ShiftCancellationReasonRequest);

  this.resourceParams = params;
  this.resourceType = 'ShiftCancellationReason';
};

exports.ShiftCancellationReasonRequest = ShiftCancellationReasonRequest;

var ShiftSearchCountRequest = function ShiftSearchCountRequest(params) {
  _classCallCheck(this, ShiftSearchCountRequest);

  this.resourceParams = params;
  this.resourceType = 'ShiftSearchCount';
};

exports.ShiftSearchCountRequest = ShiftSearchCountRequest;

var ShiftStatusRequest = function ShiftStatusRequest(params) {
  _classCallCheck(this, ShiftStatusRequest);

  this.resourceParams = params;
  this.resourceType = 'ShiftStatus';
};

exports.ShiftStatusRequest = ShiftStatusRequest;

var ShiftSearchDayCountRequest = function ShiftSearchDayCountRequest(params) {
  _classCallCheck(this, ShiftSearchDayCountRequest);

  this.resourceParams = params;
  this.resourceType = 'ShiftSearchDayCount';
};

exports.ShiftSearchDayCountRequest = ShiftSearchDayCountRequest;

var ShiftSearchRequest = function ShiftSearchRequest(params) {
  _classCallCheck(this, ShiftSearchRequest);

  this.resourceParams = params;
  this.resourceType = 'ShiftSearch';
};

exports.ShiftSearchRequest = ShiftSearchRequest;

var StorageObjectRequest = function StorageObjectRequest(params) {
  _classCallCheck(this, StorageObjectRequest);

  this.resourceParams = params;
  this.resourceType = 'StorageObject';
};

exports.StorageObjectRequest = StorageObjectRequest;

var EducationHistoryRequest = function EducationHistoryRequest(params) {
  _classCallCheck(this, EducationHistoryRequest);

  this.resourceParams = params;
  this.resourceType = 'EducationHistory';
};

exports.EducationHistoryRequest = EducationHistoryRequest;

var AboutTypeNotesRequest = function AboutTypeNotesRequest(params) {
  _classCallCheck(this, AboutTypeNotesRequest);

  this.resourceParams = params;
  this.resourceType = 'AboutTypeNotes';
};

exports.AboutTypeNotesRequest = AboutTypeNotesRequest;

var NoteRequest = function NoteRequest(params) {
  _classCallCheck(this, NoteRequest);

  this.resourceParams = params;
  this.resourceType = 'Note';
};

exports.NoteRequest = NoteRequest;

var VendorRequest = function VendorRequest(params) {
  _classCallCheck(this, VendorRequest);

  this.resourceParams = params;
  this.resourceType = 'Vendor';
};

exports.VendorRequest = VendorRequest;

var WorkHistoryRequest = function WorkHistoryRequest(params) {
  _classCallCheck(this, WorkHistoryRequest);

  this.resourceParams = params;
  this.resourceType = 'WorkHistory';
};

exports.WorkHistoryRequest = WorkHistoryRequest;

var CandidateEducationHistoryRequest = function CandidateEducationHistoryRequest(params) {
  _classCallCheck(this, CandidateEducationHistoryRequest);

  this.resourceParams = params;
  this.resourceType = 'CandidateEducationHistory';
};

exports.CandidateEducationHistoryRequest = CandidateEducationHistoryRequest;

var CandidateRequest = function CandidateRequest(params) {
  _classCallCheck(this, CandidateRequest);

  this.resourceParams = params;
  this.resourceType = 'Candidate';
};

exports.CandidateRequest = CandidateRequest;

var ClientProjectRequest = function ClientProjectRequest(params) {
  _classCallCheck(this, ClientProjectRequest);

  this.resourceParams = params;
  this.resourceType = 'ClientProject';
};

exports.ClientProjectRequest = ClientProjectRequest;

var CompanyRequest = function CompanyRequest(params) {
  _classCallCheck(this, CompanyRequest);

  this.resourceParams = params;
  this.resourceType = 'Company';
};

exports.CompanyRequest = CompanyRequest;

var ContactRequest = function ContactRequest(params) {
  _classCallCheck(this, ContactRequest);

  this.resourceParams = params;
  this.resourceType = 'Contact';
};

exports.ContactRequest = ContactRequest;

var DepartmentRequest = function DepartmentRequest(params) {
  _classCallCheck(this, DepartmentRequest);

  this.resourceParams = params;
  this.resourceType = 'Department';
};

exports.DepartmentRequest = DepartmentRequest;

var FacilityDepartmentRequest = function FacilityDepartmentRequest(params) {
  _classCallCheck(this, FacilityDepartmentRequest);

  this.resourceParams = params;
  this.resourceType = 'FacilityDepartment';
};

exports.FacilityDepartmentRequest = FacilityDepartmentRequest;

var FolderGroupRequest = function FolderGroupRequest(params) {
  _classCallCheck(this, FolderGroupRequest);

  this.resourceParams = params;
  this.resourceType = 'FolderGroup';
};

exports.FolderGroupRequest = FolderGroupRequest;

var IndustryRequest = function IndustryRequest(params) {
  _classCallCheck(this, IndustryRequest);

  this.resourceParams = params;
  this.resourceType = 'Industry';
};

exports.IndustryRequest = IndustryRequest;

var MatchEndReasonRequest = function MatchEndReasonRequest(params) {
  _classCallCheck(this, MatchEndReasonRequest);

  this.resourceParams = params;
  this.resourceType = 'MatchEndReason';
};

exports.MatchEndReasonRequest = MatchEndReasonRequest;

var MatchBillingRequest = function MatchBillingRequest(params) {
  _classCallCheck(this, MatchBillingRequest);

  this.resourceParams = params;
  this.resourceType = 'MatchBilling';
};

exports.MatchBillingRequest = MatchBillingRequest;

var MatchPeopleRequest = function MatchPeopleRequest(params) {
  _classCallCheck(this, MatchPeopleRequest);

  this.resourceParams = params;
  this.resourceType = 'MatchPeople';
};

exports.MatchPeopleRequest = MatchPeopleRequest;

var MatchScheduleRequest = function MatchScheduleRequest(params) {
  _classCallCheck(this, MatchScheduleRequest);

  this.resourceParams = params;
  this.resourceType = 'MatchSchedule';
};

exports.MatchScheduleRequest = MatchScheduleRequest;

var MatchSearchCountRequest = function MatchSearchCountRequest(params) {
  _classCallCheck(this, MatchSearchCountRequest);

  this.resourceParams = params;
  this.resourceType = 'MatchSearchCount';
};

exports.MatchSearchCountRequest = MatchSearchCountRequest;

var MatchSearchRequest = function MatchSearchRequest(params) {
  _classCallCheck(this, MatchSearchRequest);

  this.resourceParams = params;
  this.resourceType = 'MatchSearch';
};

exports.MatchSearchRequest = MatchSearchRequest;

var MatchStatusRequest = function MatchStatusRequest(params) {
  _classCallCheck(this, MatchStatusRequest);

  this.resourceParams = params;
  this.resourceType = 'MatchStatus';
};

exports.MatchStatusRequest = MatchStatusRequest;

var MatchRequest = function MatchRequest(params) {
  _classCallCheck(this, MatchRequest);

  this.resourceParams = params;
  this.resourceType = 'Match';
};

exports.MatchRequest = MatchRequest;

var MatchActionsRequest = function MatchActionsRequest(params) {
  _classCallCheck(this, MatchActionsRequest);

  this.resourceParams = params;
  this.resourceType = 'MatchActions';
};

exports.MatchActionsRequest = MatchActionsRequest;

var MatchTransitionsRequest = function MatchTransitionsRequest(params) {
  _classCallCheck(this, MatchTransitionsRequest);

  this.resourceParams = params;
  this.resourceType = 'MatchTransitions';
};

exports.MatchTransitionsRequest = MatchTransitionsRequest;

var OpportunityRequest = function OpportunityRequest(params) {
  _classCallCheck(this, OpportunityRequest);

  this.resourceParams = params;
  this.resourceType = 'Opportunity';
};

exports.OpportunityRequest = OpportunityRequest;

var PositionAccountingRequest = function PositionAccountingRequest(params) {
  _classCallCheck(this, PositionAccountingRequest);

  this.resourceParams = params;
  this.resourceType = 'PositionAccounting';
};

exports.PositionAccountingRequest = PositionAccountingRequest;

var PositionBillingRequest = function PositionBillingRequest(params) {
  _classCallCheck(this, PositionBillingRequest);

  this.resourceParams = params;
  this.resourceType = 'PositionBilling';
};

exports.PositionBillingRequest = PositionBillingRequest;

var PositionCreationReasonRequest = function PositionCreationReasonRequest(params) {
  _classCallCheck(this, PositionCreationReasonRequest);

  this.resourceParams = params;
  this.resourceType = 'PositionCreationReason';
};

exports.PositionCreationReasonRequest = PositionCreationReasonRequest;

var PositionRequest = function PositionRequest(params) {
  _classCallCheck(this, PositionRequest);

  this.resourceParams = params;
  this.resourceType = 'Position';
};

exports.PositionRequest = PositionRequest;

var PositionLocationRequest = function PositionLocationRequest(params) {
  _classCallCheck(this, PositionLocationRequest);

  this.resourceParams = params;
  this.resourceType = 'PositionLocation';
};

exports.PositionLocationRequest = PositionLocationRequest;

var PositionScheduleRequest = function PositionScheduleRequest(params) {
  _classCallCheck(this, PositionScheduleRequest);

  this.resourceParams = params;
  this.resourceType = 'PositionSchedule';
};

exports.PositionScheduleRequest = PositionScheduleRequest;

var PositionSearchCountRequest = function PositionSearchCountRequest(params) {
  _classCallCheck(this, PositionSearchCountRequest);

  this.resourceParams = params;
  this.resourceType = 'PositionSearchCount';
};

exports.PositionSearchCountRequest = PositionSearchCountRequest;

var PositionSearchRequest = function PositionSearchRequest(params) {
  _classCallCheck(this, PositionSearchRequest);

  this.resourceParams = params;
  this.resourceType = 'PositionSearch';
};

exports.PositionSearchRequest = PositionSearchRequest;

var PositionStatusRequest = function PositionStatusRequest(params) {
  _classCallCheck(this, PositionStatusRequest);

  this.resourceParams = params;
  this.resourceType = 'PositionStatus';
};

exports.PositionStatusRequest = PositionStatusRequest;

var PositionTemplateBillRatesRequest = function PositionTemplateBillRatesRequest(params) {
  _classCallCheck(this, PositionTemplateBillRatesRequest);

  this.resourceParams = params;
  this.resourceType = 'PositionTemplateBillRates';
};

exports.PositionTemplateBillRatesRequest = PositionTemplateBillRatesRequest;

var PositionTemplateDetailsRequest = function PositionTemplateDetailsRequest(params) {
  _classCallCheck(this, PositionTemplateDetailsRequest);

  this.resourceParams = params;
  this.resourceType = 'PositionTemplateDetails';
};

exports.PositionTemplateDetailsRequest = PositionTemplateDetailsRequest;

var PositionTemplateCompaniesRequest = function PositionTemplateCompaniesRequest(params) {
  _classCallCheck(this, PositionTemplateCompaniesRequest);

  this.resourceParams = params;
  this.resourceType = 'PositionTemplateCompanies';
};

exports.PositionTemplateCompaniesRequest = PositionTemplateCompaniesRequest;

var PositionTemplateRequest = function PositionTemplateRequest(params) {
  _classCallCheck(this, PositionTemplateRequest);

  this.resourceParams = params;
  this.resourceType = 'PositionTemplate';
};

exports.PositionTemplateRequest = PositionTemplateRequest;

var PositionTypeRequest = function PositionTypeRequest(params) {
  _classCallCheck(this, PositionTypeRequest);

  this.resourceParams = params;
  this.resourceType = 'PositionType';
};

exports.PositionTypeRequest = PositionTypeRequest;

var ProcessingProfileRequest = function ProcessingProfileRequest(params) {
  _classCallCheck(this, ProcessingProfileRequest);

  this.resourceParams = params;
  this.resourceType = 'ProcessingProfile';
};

exports.ProcessingProfileRequest = ProcessingProfileRequest;

var RateGroupRequest = function RateGroupRequest(params) {
  _classCallCheck(this, RateGroupRequest);

  this.resourceParams = params;
  this.resourceType = 'RateGroup';
};

exports.RateGroupRequest = RateGroupRequest;

var MatchRequirementProgressRequest = function MatchRequirementProgressRequest(params) {
  _classCallCheck(this, MatchRequirementProgressRequest);

  this.resourceParams = params;
  this.resourceType = 'MatchRequirementProgress';
};

exports.MatchRequirementProgressRequest = MatchRequirementProgressRequest;

var RequirementAttachmentsRequest = function RequirementAttachmentsRequest(params) {
  _classCallCheck(this, RequirementAttachmentsRequest);

  this.resourceParams = params;
  this.resourceType = 'RequirementAttachments';
};

exports.RequirementAttachmentsRequest = RequirementAttachmentsRequest;

var RequirementDetailsRequest = function RequirementDetailsRequest(params) {
  _classCallCheck(this, RequirementDetailsRequest);

  this.resourceParams = params;
  this.resourceType = 'RequirementDetails';
};

exports.RequirementDetailsRequest = RequirementDetailsRequest;

var PositionShiftTypesRequest = function PositionShiftTypesRequest(params) {
  _classCallCheck(this, PositionShiftTypesRequest);

  this.resourceParams = params;
  this.resourceType = 'PositionShiftTypes';
};

exports.PositionShiftTypesRequest = PositionShiftTypesRequest;

var ShiftTypeRequest = function ShiftTypeRequest(params) {
  _classCallCheck(this, ShiftTypeRequest);

  this.resourceParams = params;
  this.resourceType = 'ShiftType';
};

exports.ShiftTypeRequest = ShiftTypeRequest;

var CompanyWorksitesRequest = function CompanyWorksitesRequest(params) {
  _classCallCheck(this, CompanyWorksitesRequest);

  this.resourceParams = params;
  this.resourceType = 'CompanyWorksites';
};

exports.CompanyWorksitesRequest = CompanyWorksitesRequest;

var QuickSearchRequest = function QuickSearchRequest(params) {
  _classCallCheck(this, QuickSearchRequest);

  this.resourceParams = params;
  this.resourceType = 'QuickSearch';
};

exports.QuickSearchRequest = QuickSearchRequest;

var WorksiteRequest = function WorksiteRequest(params) {
  _classCallCheck(this, WorksiteRequest);

  this.resourceParams = params;
  this.resourceType = 'Worksite';
};

exports.WorksiteRequest = WorksiteRequest;

var ObjectRequirementStatusRequest = function ObjectRequirementStatusRequest(params) {
  _classCallCheck(this, ObjectRequirementStatusRequest);

  this.resourceParams = params;
  this.resourceType = 'ObjectRequirementStatus';
};

exports.ObjectRequirementStatusRequest = ObjectRequirementStatusRequest;

var AvailableRequirementStatusesRequest = function AvailableRequirementStatusesRequest(params) {
  _classCallCheck(this, AvailableRequirementStatusesRequest);

  this.resourceParams = params;
  this.resourceType = 'AvailableRequirementStatuses';
};

exports.AvailableRequirementStatusesRequest = AvailableRequirementStatusesRequest;

var RejectApprovalPathRequest = function RejectApprovalPathRequest(params) {
  _classCallCheck(this, RejectApprovalPathRequest);

  this.mutationParams = params;
  this.mutationType = 'RejectApprovalPath';
};

exports.RejectApprovalPathRequest = RejectApprovalPathRequest;

var SubmitProblemRequest = function SubmitProblemRequest(params) {
  _classCallCheck(this, SubmitProblemRequest);

  this.mutationParams = params;
  this.mutationType = 'SubmitProblem';
};

exports.SubmitProblemRequest = SubmitProblemRequest;

var CancelShiftRequest = function CancelShiftRequest(params) {
  _classCallCheck(this, CancelShiftRequest);

  this.mutationParams = params;
  this.mutationType = 'CancelShift';
};

exports.CancelShiftRequest = CancelShiftRequest;

var UpdateUserNotificationSettingRequest = function UpdateUserNotificationSettingRequest(params) {
  _classCallCheck(this, UpdateUserNotificationSettingRequest);

  this.mutationParams = params;
  this.mutationType = 'UpdateUserNotificationSetting';
};

exports.UpdateUserNotificationSettingRequest = UpdateUserNotificationSettingRequest;

var RegisterUserNotificationDeviceRequest = function RegisterUserNotificationDeviceRequest(params) {
  _classCallCheck(this, RegisterUserNotificationDeviceRequest);

  this.mutationParams = params;
  this.mutationType = 'RegisterUserNotificationDevice';
};

exports.RegisterUserNotificationDeviceRequest = RegisterUserNotificationDeviceRequest;

var UnregisterUserNotificationDeviceRequest = function UnregisterUserNotificationDeviceRequest(params) {
  _classCallCheck(this, UnregisterUserNotificationDeviceRequest);

  this.mutationParams = params;
  this.mutationType = 'UnregisterUserNotificationDevice';
};

exports.UnregisterUserNotificationDeviceRequest = UnregisterUserNotificationDeviceRequest;

var MarkUserNotificationAsReadRequest = function MarkUserNotificationAsReadRequest(params) {
  _classCallCheck(this, MarkUserNotificationAsReadRequest);

  this.mutationParams = params;
  this.mutationType = 'MarkUserNotificationAsRead';
};

exports.MarkUserNotificationAsReadRequest = MarkUserNotificationAsReadRequest;

var UpdateCustomFieldRequest = function UpdateCustomFieldRequest(params) {
  _classCallCheck(this, UpdateCustomFieldRequest);

  this.mutationParams = params;
  this.mutationType = 'UpdateCustomField';
};

exports.UpdateCustomFieldRequest = UpdateCustomFieldRequest;

var ExportShiftSearchRequest = function ExportShiftSearchRequest(params) {
  _classCallCheck(this, ExportShiftSearchRequest);

  this.mutationParams = params;
  this.mutationType = 'ExportShiftSearch';
};

exports.ExportShiftSearchRequest = ExportShiftSearchRequest;

var ApproveApprovalPathRequest = function ApproveApprovalPathRequest(params) {
  _classCallCheck(this, ApproveApprovalPathRequest);

  this.mutationParams = params;
  this.mutationType = 'ApproveApprovalPath';
};

exports.ApproveApprovalPathRequest = ApproveApprovalPathRequest;

var SetDataPreferencesRequest = function SetDataPreferencesRequest(params) {
  _classCallCheck(this, SetDataPreferencesRequest);

  this.mutationParams = params;
  this.mutationType = 'SetDataPreferences';
};

exports.SetDataPreferencesRequest = SetDataPreferencesRequest;

var DeleteShiftRequest = function DeleteShiftRequest(params) {
  _classCallCheck(this, DeleteShiftRequest);

  this.mutationParams = params;
  this.mutationType = 'DeleteShift';
};

exports.DeleteShiftRequest = DeleteShiftRequest;

var NewShiftsRequest = function NewShiftsRequest(params) {
  _classCallCheck(this, NewShiftsRequest);

  this.mutationParams = params;
  this.mutationType = 'NewShifts';
};

exports.NewShiftsRequest = NewShiftsRequest;

var UpdateNoteRequest = function UpdateNoteRequest(params) {
  _classCallCheck(this, UpdateNoteRequest);

  this.mutationParams = params;
  this.mutationType = 'UpdateNote';
};

exports.UpdateNoteRequest = UpdateNoteRequest;

var DeleteNoteRequest = function DeleteNoteRequest(params) {
  _classCallCheck(this, DeleteNoteRequest);

  this.mutationParams = params;
  this.mutationType = 'DeleteNote';
};

exports.DeleteNoteRequest = DeleteNoteRequest;

var ExportMatchSearchRequest = function ExportMatchSearchRequest(params) {
  _classCallCheck(this, ExportMatchSearchRequest);

  this.mutationParams = params;
  this.mutationType = 'ExportMatchSearch';
};

exports.ExportMatchSearchRequest = ExportMatchSearchRequest;

var ExportPositionSearchRequest = function ExportPositionSearchRequest(params) {
  _classCallCheck(this, ExportPositionSearchRequest);

  this.mutationParams = params;
  this.mutationType = 'ExportPositionSearch';
};

exports.ExportPositionSearchRequest = ExportPositionSearchRequest;

var DivisionRequest = function DivisionRequest(params) {
  _classCallCheck(this, DivisionRequest);

  this.mutationParams = params;
  this.mutationType = 'Division';
};

exports.DivisionRequest = DivisionRequest;

var SetStorageObjectRequest = function SetStorageObjectRequest(params) {
  _classCallCheck(this, SetStorageObjectRequest);

  this.mutationParams = params;
  this.mutationType = 'SetStorageObject';
};

exports.SetStorageObjectRequest = SetStorageObjectRequest;

var MatchMakeOfferRequest = function MatchMakeOfferRequest(params) {
  _classCallCheck(this, MatchMakeOfferRequest);

  this.mutationParams = params;
  this.mutationType = 'MatchMakeOffer';
};

exports.MatchMakeOfferRequest = MatchMakeOfferRequest;

var MatchInviteForInterviewRequest = function MatchInviteForInterviewRequest(params) {
  _classCallCheck(this, MatchInviteForInterviewRequest);

  this.mutationParams = params;
  this.mutationType = 'MatchInviteForInterview';
};

exports.MatchInviteForInterviewRequest = MatchInviteForInterviewRequest;

var MatchRejectRequest = function MatchRejectRequest(params) {
  _classCallCheck(this, MatchRejectRequest);

  this.mutationParams = params;
  this.mutationType = 'MatchReject';
};

exports.MatchRejectRequest = MatchRejectRequest;

var NewNoteRequest = function NewNoteRequest(params) {
  _classCallCheck(this, NewNoteRequest);

  this.mutationParams = params;
  this.mutationType = 'NewNote';
};

exports.NewNoteRequest = NewNoteRequest;

var ClosePositionRequest = function ClosePositionRequest(params) {
  _classCallCheck(this, ClosePositionRequest);

  this.mutationParams = params;
  this.mutationType = 'ClosePosition';
};

exports.ClosePositionRequest = ClosePositionRequest;

var NewPositionRequest = function NewPositionRequest(params) {
  _classCallCheck(this, NewPositionRequest);

  this.mutationParams = params;
  this.mutationType = 'NewPosition';
};

exports.NewPositionRequest = NewPositionRequest;

var UpdatePositionAccountingRequest = function UpdatePositionAccountingRequest(params) {
  _classCallCheck(this, UpdatePositionAccountingRequest);

  this.mutationParams = params;
  this.mutationType = 'UpdatePositionAccounting';
};

exports.UpdatePositionAccountingRequest = UpdatePositionAccountingRequest;

var UpdatePositionBillingRequest = function UpdatePositionBillingRequest(params) {
  _classCallCheck(this, UpdatePositionBillingRequest);

  this.mutationParams = params;
  this.mutationType = 'UpdatePositionBilling';
};

exports.UpdatePositionBillingRequest = UpdatePositionBillingRequest;

var UpdatePositionRequest = function UpdatePositionRequest(params) {
  _classCallCheck(this, UpdatePositionRequest);

  this.mutationParams = params;
  this.mutationType = 'UpdatePosition';
};

exports.UpdatePositionRequest = UpdatePositionRequest;

var UpdatePositionLocationRequest = function UpdatePositionLocationRequest(params) {
  _classCallCheck(this, UpdatePositionLocationRequest);

  this.mutationParams = params;
  this.mutationType = 'UpdatePositionLocation';
};

exports.UpdatePositionLocationRequest = UpdatePositionLocationRequest;

var UpdatePositionScheduleRequest = function UpdatePositionScheduleRequest(params) {
  _classCallCheck(this, UpdatePositionScheduleRequest);

  this.mutationParams = params;
  this.mutationType = 'UpdatePositionSchedule';
};

exports.UpdatePositionScheduleRequest = UpdatePositionScheduleRequest;

var ZipRequirementAttachmentsRequest = function ZipRequirementAttachmentsRequest(params) {
  _classCallCheck(this, ZipRequirementAttachmentsRequest);

  this.mutationParams = params;
  this.mutationType = 'ZipRequirementAttachments';
};

exports.ZipRequirementAttachmentsRequest = ZipRequirementAttachmentsRequest;